import React, { FC } from 'react';

//mui components
import {
  Button,
  Grid,
  Modal,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

//styles
import styles from './styles.module.scss';

// remixicon
import CloseLineIcon from 'remixicon-react/CloseLineIcon';

interface DeletePostCategoryModalProps {
  open: boolean;
  onClose: () => void;
  postCategoryTitle: string;
  onDelete: () => void;
  isLoadingDeletePostCategory: boolean;
}

const DeletePostCategoryModal: FC<DeletePostCategoryModalProps> = ({
  open,
  onClose,
  postCategoryTitle,
  onDelete,
  isLoadingDeletePostCategory,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ backdropFilter: 'blur(10px)' }}
    >
      <Grid className={styles.modal}>
        <Typography className={styles.modalTitle} variant="h6">
          {`Please confirm if you want to permanently remove the category "${postCategoryTitle}". This action is irreversible.`}
        </Typography>
        <Box
          display={'flex'}
          justifyContent={'center'}
          gap={'10px'}
          width={'100%'}
        >
          <Button
            variant="outlined"
            color="primary"
            disableElevation
            className={`${styles.button} ${styles.buttonCancel}`}
            onClick={onClose}
          >
            Cancel
          </Button>
          <LoadingButton
            startIcon={
              isLoadingDeletePostCategory && (
                <CircularProgress
                  sx={{ color: 'var(--neutral-white)' }}
                  size={'16px'}
                />
              )
            }
            loadingPosition={isLoadingDeletePostCategory ? 'start' : undefined}
            className={styles.button}
            onClick={onDelete}
            variant="contained"
            color="primary"
            fullWidth
            disableElevation
            disabled={isLoadingDeletePostCategory}
          >
            Delete
          </LoadingButton>
        </Box>

        <IconButton className={styles.buttonClose} onClick={onClose}>
          <CloseLineIcon />
        </IconButton>
      </Grid>
    </Modal>
  );
};

export default DeletePostCategoryModal;
